/**
 * Author: Andy Chipalu
 * jquery plugin for displaying notification
 * Dependency : jquery library, base stylesheet
 *
 */
import $ from 'jquery';



export const notification = () => {
	const notificationSelector= $('.contentContainer--notificationContent');

	const buttonClose = (element) => {
		//$(element).append("<div class='notification_close'></div>");

		$(element).find(".notificationClose").on("click",function(){
			var node_pointer=$(this).closest(".contentContainer--notificationContent").attr('node_pointer');
			$.post(
					'/notification/close', // url
					 { id: node_pointer},
					function(data){
						 console.log("result",data)
					}
			);
			$(this).closest(".contentContainer--notificationContent").hide(1500);
		});

		$(element).find(".closePermanently").on("click",function(){
			var node_pointer=$(this).closest(".contentContainer--notificationContent").attr('node_pointer');

			var ntf_cookie= getCookie('u2_notification');
			if(ntf_cookie != false){
				var start= ntf_cookie.indexOf(node_pointer+"@");
				var end= ntf_cookie.indexOf("++",start);
				var old_value=ntf_cookie.substr(start,end-start);
				var new_value= node_pointer+"@1893456000"; //2030 date
				var ntf_cookie=ntf_cookie.replace(old_value,new_value);
				setCookie('sting_notification',ntf_cookie,500000);
			}
			$(this).closest(".user_notification_container").hide(1500);

		});

	};

	buttonClose(notificationSelector);

};
